import '../ActivityActions.scss';
import React, { useEffect, useMemo, useState } from 'react';
import { MdOutlineAltRoute } from 'react-icons/md';
import { IResolveExceptionModel } from '@models/document/activityExecutors/IResolveExceptionModel';
import { ActivityExecutionService } from '@services/actions/ActivityExecutionService';
import { useForm } from 'react-hook-form';
import ModalContainer, { IModalContainerProps } from '@molecules/ModalContainer/ModalContainer';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import SelectableList from '@srm/ui/selectable-list';
import { IResolveExceptionProps } from './IResolveExceptionProps';

export const ResolveExceptionModal: React.FC<IResolveExceptionProps> = (props: IResolveExceptionProps) => {
    const [actionModel, setActionModel] = useState<IResolveExceptionModel>();
    const [templateId, setTemplateId] = useState<string>('');

    const serv = useMemo(() => new ActivityExecutionService(), []);

    const { errorText, setErrorText, isBusy, setIsBusy, isSubmitting, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        initialBusy: true,
        submit: () => serv.saveResolveException(props.actionKey, props.activityId, templateId),
    });

    useEffect(() => {
        // Закрытое окно ответ подготовки не применяет.
        let ignore = false;
        setIsBusy(true);

        serv.getResolveExceptionModel(props.actionKey, props.activityId)
            .then((res) => {
                if (!ignore) setActionModel(res.data);
            })
            .catch(() => {
                if (!ignore) setErrorText('Ошибка получения данных от сервера.');
            })
            .finally(() => {
                if (!ignore) setIsBusy(false);
            });
        return () => {
            ignore = true;
        };
    }, []);

    const onSubmit = () => {
        if (templateId == '') {
            setErrorText('Не указан шаг маршрута');
            return;
        }

        return okClick();
    };

    const formState = useForm<any>({
        mode: 'onBlur', // "onChange"
    });

    const modalContainerProps: IModalContainerProps = {
        header: props.title,
        size: props.modalSize,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        loading: isBusy,
        closeDisabled: isSubmitting,
        hasUnsavedInput: () => templateId !== '',
        onCancel: cancelClick,
        errorText: errorText,
        formMethods: formState,
        onSubmit: onSubmit,
    };

    // Шаг маршрута выбирается один: список сам держит режим одиночного выбора,
    // поэтому ручного снятия остальных строк больше не нужно.
    const activities = useMemo(
        () =>
            (actionModel?.activities ?? []).map((activity) => ({
                key: activity.templateId,
                title: activity.activityName,
                subtitle: activity.performerName,
                icon: <MdOutlineAltRoute size={18} />,
            })),
        [actionModel?.activities],
    );

    return (
        <ModalContainer {...modalContainerProps}>
            <SelectableList
                mode="single"
                items={activities}
                selected={templateId ? [templateId] : []}
                onChange={(keys) => setTemplateId(keys[0] ?? '')}
                emptyText="Нет доступных этапов маршрута"
                ariaLabel="Этапы маршрута"
            />
        </ModalContainer>
    );
};
